var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainArrowBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_49)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_49",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.307617V16.3076H0.5V0.307617H16.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.30762C1.5 10.1641 2.2375 11.9446 3.55025 13.2574C4.86301 14.5701 6.64348 15.3076 8.5 15.3076C10.3565 15.3076 12.137 14.5701 13.4497 13.2574C14.7625 11.9446 15.5 10.1641 15.5 8.30762C15.5 6.4511 14.7625 4.67062 13.4497 3.35787C12.137 2.04511 10.3565 1.30762 8.5 1.30762C6.64348 1.30762 4.86301 2.04511 3.55025 3.35787C2.2375 4.67062 1.5 6.4511 1.5 8.30762Z",
    stroke: "#8C8C8C",
    strokeOpacity: 0.4,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.30762L8.5 9.80762L11 7.30762",
    stroke: "#8C8C8C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.307617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainArrowBottom);
export default __webpack_public_path__ + "static/media/main-arrow-bottom.ed3dec5cf8600e6ce1086eb0a4ae437d.svg";
export { ForwardRef as ReactComponent };